"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PercentageInput = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _percentageInputModule = _interopRequireDefault(require("./percentage-input.module.scss"));
var _NumberInput = require("../number-input/NumberInput");
var _excluded = ["id", "name", "value", "min", "max", "onChange"];
var PercentageInput = function PercentageInput(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _percentageInputModule.default['percentage-input']
  }, /*#__PURE__*/_react.default.createElement(_NumberInput.NumberInput, Object.assign({
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    min: min,
    max: max,
    className: _percentageInputModule.default['percentage-input__input']
  }, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: _percentageInputModule.default['percentage-input__percentage']
  }, "%"));
};
exports.PercentageInput = PercentageInput;